import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import {
  useTaskModelVersion,
  setTaskModelVersion,
} from "../../redux/reducers/AppStateReducer";
import { taskModelVersionChanged } from "../../redux/sagas/experienceLog/formDataSaga";
import CustomModal from "../CustomModal/CustomModal";
import ConfirmationPopup from "../ConfirmationPopup/ConfirmationPopup";
import { V6_COMPULSORY_MESSAGE } from "../../utils/CONSTANTS";

const VersionToggler = () => {
  const version = useTaskModelVersion();
  const dispatch = useDispatch();
  const location = useLocation();
  const [v6CompulsoryModalVisible, setV6CompulsoryModalVisible] =
    useState(false);

  const isV6 = version === "v6";

  const toggleVersion = () => {
    if (location.pathname === "/student/logHour" && isV6) {
      setV6CompulsoryModalVisible(true);
      return;
    }

    dispatch(setTaskModelVersion(isV6 ? "v5" : "v6"));
    dispatch(taskModelVersionChanged());
  };

  return (
    <div
      style={{
        position: "absolute",
        right: 20,
        zIndex: 1000,
        display: "flex",
        alignItems: "center",
        gap: 10,
        fontFamily: "sans-serif",
      }}
    >
      <CustomModal
        modalVisible={v6CompulsoryModalVisible}
        onClose={setV6CompulsoryModalVisible}
        maxWidth="450px"
      >
        <ConfirmationPopup
          setModalVisible={setV6CompulsoryModalVisible}
          message={V6_COMPULSORY_MESSAGE}
        />
      </CustomModal>
      <span
        style={{
          fontWeight: isV6 ? 400 : 600,
          color: isV6 ? "#888" : "#000",
        }}
      >
        5th Edition
      </span>

      <div
        onClick={toggleVersion}
        style={{
          width: 50,
          height: 26,
          borderRadius: 999,
          backgroundColor: isV6 ? "#4CAF50" : "#ccc",
          position: "relative",
          cursor: "pointer",
          transition: "background-color 0.3s ease",
        }}
      >
        <div
          style={{
            width: 22,
            height: 22,
            borderRadius: "50%",
            backgroundColor: "#fff",
            position: "absolute",
            top: 2,
            left: isV6 ? 26 : 2,
            transition: "left 0.3s ease",
            boxShadow: "0 1px 4px rgba(0,0,0,0.2)",
          }}
        />
      </div>

      <span
        style={{
          fontWeight: isV6 ? 600 : 400,
          color: isV6 ? "#000" : "#888",
        }}
      >
        6th Edition
      </span>
    </div>
  );
};

export default VersionToggler;
